import axiosActionsFactory from '../axiosHelpers';
import UrlService from '../../../services/UrlService';

export const CSV_IMPORT_PREVIEW = axiosActionsFactory('CSV_IMPORT_PREVIEW_LOAD');
export const CSV_IMPORT = axiosActionsFactory('CSV_IMPORT_LOAD');
export const CSV_REANALYZE = axiosActionsFactory('CSV_REANALYZE_LOAD');

export const csvPreviewOrders = (file, contextCompanyId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('contextCompanyId', contextCompanyId);

  return (dispatch) => dispatch({
    type: CSV_IMPORT_PREVIEW.START,
    payload: {
      request: {
        url: UrlService.csvImportAnalyzeFile(),
        method: 'post',
        data: formData,
        params: { contextCompanyId },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    },
  });
};

export const csvImportOrders = (orders, contextCompanyId) => (
  (dispatch) => dispatch({
    type: CSV_IMPORT.START,
    payload: {
      request: {
        url: UrlService.csvImportImport(),
        method: 'post',
        data: { orders },
        params: { contextCompanyId },
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  })
);

export const csvReanalyzeOrders = (orders, contextCompanyId) => (
  (dispatch) => dispatch({
    type: CSV_REANALYZE.START,
    payload: {
      request: {
        url: UrlService.csvImportAnalyze(),
        method: 'post',
        data: { orders },
        params: { contextCompanyId },
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  })
);
